import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import s from "./ads_styles/AdsSearch.module.css";
import AdsSearch from "./AdsSearch";

export default function AdsModal({ project, projectId, onClose, endpoint }) {
  const pid = projectId ?? project?.id;

  // Хуки вызываем всегда; внутри эффекта — ранний выход, если pid нет
  useEffect(() => {
    if (!pid) return;

    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    document.body.classList.add("modal-open");
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.classList.remove("modal-open");
    };
  }, [pid, onClose]);

  if (!pid) return null;

  const modal = (
    <div
      className={s.modalOverlay}
      onMouseDown={(e) => {
        // клик по фону — закрыть
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className={s.modalContent}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        onDragStart={(e) => e.preventDefault()}
        style={{ width: "97%", maxHeight: "100vh", overflow: "auto" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 0 0 10px" }}>
          <h3 style={{ margin: 0 }}>Объявления проекта #{pid}</h3>
          <button className={s.modalClose} onClick={onClose}>✕</button>
        </div>

        <div style={{ marginTop: 5 }}>
          <AdsSearch projectId={pid} endpoint={endpoint} />
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
